// This folder contains all the actions possible with redux, this way you can not have accidental typos

export const GET_RKLIST = "GET_RKLIST";
export const SAVE_DATA = "SAVE_DATA";
export const SET_RK = "SET_RK";

export const SET_LOADER = "SET_LOADER";

export const SET_UURTARIEVEN = "SET_UURTARIEVEN";

export const ADD_RK_MODAL = "ADD_RK_MODAL";
export const SET_RK_MODAL = "SET_RK_MODAL";
export const DELETE_RK_MODAL = "DELETE_RK_MODAL";
export const RESET_RK_MODAL = "RESET_RK_MODAL";

export const SET_ADMIN = "SET_ADMIN";
